// Ref: https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/menu.ts

import { transparentize } from '@/util/chakra';
import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import {
    createMultiStyleConfigHelpers,
    defineStyle,
} from '@chakra-ui/styled-system';
import { mode } from '@chakra-ui/theme-tools';

const { defineMultiStyleConfig, definePartsStyle } =
    createMultiStyleConfigHelpers(parts.keys);

const baseStyleList = defineStyle((props) => {
    return {
        bg: mode('white', 'gray.700')(props),
        boxShadow: 'sm',
        color: mode('textDark', 'textLight')(props),
        minW: '3xs',
        py: '1rem',
        zIndex: 2,
        borderRadius: 'md',
        borderWidth: mode('1px', '0')(props),
        borderColor: mode('border', 'transparent')(props),
    };
});

const baseStyleItem = defineStyle((props) => {
    const { theme } = props;
    const highlight = transparentize('indigo.200', 0.15)(theme);

    return {
        py: '0.5rem',
        px: '1.5rem',
        transitionProperty: 'background',
        transitionDuration: 'ultra-fast',
        transitionTimingFunction: 'ease-in',
        bg: mode('white', 'gray.700')(props),
        fontSize: 'md',
        _focus: {
            bg: mode(highlight, 'blackAlpha.300')(props),
        },
        _active: {
            bg: mode(highlight, 'blackAlpha.400')(props),
        },
        _expanded: {
            bg: mode(highlight, 'blackAlpha.300')(props),
        },
        _hover: {
            bg: mode(highlight, 'blackAlpha.300')(props),
        },
        _disabled: {
            opacity: 0.4,
            cursor: 'not-allowed',
        },
    };
});

const baseStyleGroupTitle = defineStyle({
    mx: '1.5rem',
    my: '0.5rem',
    fontWeight: 'semibold',
    fontSize: 'md',
    textAlign: 'left',
});

const baseStyleCommand = defineStyle({
    opacity: 0.6,
});

const baseStyleDivider = defineStyle({
    border: 0,
});

const baseStyleButton = defineStyle({
    transitionProperty: 'common',
    transitionDuration: 'normal',
});

const baseStyle = definePartsStyle((props) => ({
    button: baseStyleButton,
    list: baseStyleList(props),
    item: baseStyleItem(props),
    groupTitle: baseStyleGroupTitle,
    command: baseStyleCommand,
    divider: baseStyleDivider,
}));

const menuTheme = defineMultiStyleConfig({
    baseStyle,
});

export default menuTheme;
